import styles from "./Loader.module.scss";

const Loader = ({ className }: { className?: string }) => {
  return (
    <div className={styles.loaderWrapper}>
      <div className={`spinner-border ${className}`} role="status"></div>
    </div>
  );
};

export default Loader;
